import React, { useState, useEffect } from 'react';
import config from './footerConfig';
import Link from 'next/link';
import FooterContact from './FooterContact';
import FooterLinks from './FooterLinks';
import FooterApps from './FooterApps';

// Footer is intentionally rendered client-side only (useMounted) to reduce
// SSR CPU/memory load on production servers. A height-matched placeholder is
// rendered on the server to pre-reserve the footer's space and prevent CLS.
function useMounted() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}

const Footer = () => {
  const mounted = useMounted();
  if (!mounted) {
    return <div className="footer-placeholder" aria-hidden="true" />;
  }
  return (
    <footer className="footer wrapper">
      <div className="footer-contents container">
        <div className="footer-logo-donate">
          <h2 className="footer-logo">
            <img
              width={140}
              height={28}
              src="/img/mpr-logo-footer.svg"
              alt="Minnesota Public Radio"
            />
          </h2>
          <div className="footer-donate">
            <Link
              href="https://support.mpr.org/news-web"
              passHref
              className="btn btn-primary btn-slim small-gap"
              target="_blank"
              aria-label="Donate Now - Link opens in a new tab"
            >
              <span className="type-lg icon-heart">♡</span>Donate Now
            </Link>
          </div>
        </div>
        <FooterLinks links={config.nav} />
        <FooterApps links={config.apps} />
        <FooterContact links={config.contact} />
        <div className="footer-copyright type-sm">
          &copy; {new Date().getFullYear()} Minnesota Public Radio. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
